import i18next from 'i18next';
import PasswordValidator from './PasswordValidator';

export default class UppercaseValidator extends PasswordValidator {
  constructor(passwordPolicy) {
    const { uppercaseRange } = passwordPolicy;

    const { min, max } = uppercaseRange;

    let translation = null;

    if (min !== undefined && max !== undefined) {
      translation = i18next.t('organization.password-rules.uppercase-constraint-1', { min, max });
    } else if (min !== undefined) {
      translation = i18next.t('organization.password-rules.uppercase-constraint-2', { min });
    } else if (max !== undefined) {
      translation = i18next.t('organization.password-rules.uppercase-constraint-3', { max });
    }

    super(uppercaseRange, 'uppercase_range', false, translation);
  }

  validate(password) {
    if (this.policy) {
      const uppercaseChars = password.match(/[A-Z]/g);

      const min = this.policy.min ? this.policy.min : 0;
      const max = this.policy.max ? this.policy.max : 128;

      const numberUppercase = uppercaseChars ? uppercaseChars.length : 0;

      if (min > numberUppercase || max < numberUppercase) {
        return false;
      }
    }

    return true;
  }
}
